import { useCallback, useEffect, useState } from 'react';

import { getFormDefinitionsListCached } from './formDefinitionsCache';

const mapRowsToOptions = (rows) => {
  if (!Array.isArray(rows)) {
    return [];
  }
  return rows
    .map((f) => ({
      id: f.id,
      name: f.name ?? '',
      active: Boolean(f.active ?? f.is_active),
      schema: f.schema ?? null,
    }))
    .filter((f) => f.active);
};

/**
 * Loads portal form definitions whenever the modal opens (fresh GET each time).
 * @param {boolean} open
 * @param {() => void} [onClose]
 */
export function useAttachFormModalHook(open, onClose) {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (!open) {
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    getFormDefinitionsListCached({ force: true })
      .then((rows) => {
        if (!cancelled) {
          setForms(mapRowsToOptions(rows));
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError('Could not load forms.');
          setForms([]);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [open]);

  return {
    forms,
    loading,
    error,
    handleClose,
  };
}
